export default __webpack_public_path__ + "static/media/recycling-icon.cf5bfaca.svg";